import _ from "lodash";

let _this;
let activeVideoIndex = 0;
const timeouts = [];

const imageDuration = 5000;
const timeUpdateInterval = 100;

export const MediaContentHook = {
  mounted() {
    _this = this;
    activeVideoIndex = 0;
    renderVideo(this.el);
  },
  destroyed() {
    clearTimeouts();
  },
};

function renderVideo(el) {
  const videos = JSON.parse(el.dataset.urls);
  const path = videos[activeVideoIndex];
  const extension = path.split(".").pop();

  if (["png", "jpg", "jpeg"].includes(extension)) {
    setVideoPoster(el, videos);
  }

  el.addEventListener("ended", () => {
    startNewVideo(el, videos);
  });

  let i = 1;

  // Current design is overprocessing
  // client -> plays a video
  //        -> video calls back timeupdate at 4Hz and 66Hz
  //        -> push to server percent of read
  // server -> update progress to percent of read
  //
  // We dont need the server roundtrip to display progress!
  // We may also reduce the progress threshold, given video is 10s:
  // at 4Hz, we send an update each 2.5%
  // at 66Hz, we send an update each 0.15%
  el.addEventListener("timeupdate", (e) => {
    const t = setTimeout(() => {
      if (e.target) {
        const readingPercent = _.round(
          (_.round(e.target.currentTime, 1) / e.target.duration) * 100,
        );
        if (readingPercent) {
          pushReadingPercent(el, readingPercent);
        }
      }
    }, timeUpdateInterval * i);
    // What a mem leak!
    timeouts.push(t);
    i++;
  });
}

function updateVideoSrc(el, videos) {
  const path = videos[activeVideoIndex];
  const extension = path.split(".").pop();

  if (["png", "jpg", "jpeg"].includes(extension)) {
    setVideoPoster(el, videos);
  } else {
    el.src = videos[activeVideoIndex];
    const playPromise = el.play();

    if (playPromise !== undefined) {
      playPromise.then((_) => {}).catch((_error) => {});
    }
  }
}

function setVideoPoster(el, videos) {
  el.setAttribute("poster", videos[activeVideoIndex]);
  el.src = "";

  let i = 1;

  const myTimer = setInterval(() => {
    const readingPercent = _.round((_.round(i * timeUpdateInterval, 1) / imageDuration) * 100);
    pushReadingPercent(el, readingPercent);
    i++;
  }, timeUpdateInterval);

  window.setTimeout(() => {
    clearInterval(myTimer);
    startNewVideo(el, videos);
  }, imageDuration);
}

function startNewVideo(el, videos) {
  pushReadingPercent(el, 0);
  pushActiveVideoIndex(el, videos);
  updateVideoSrc(el, videos);
}

function pushReadingPercent(el, readingPercent) {
  if (el.dataset.timePhxEvent) {
    _this.pushEvent(el.dataset.timePhxEvent, readingPercent);
  }
}

function pushActiveVideoIndex(el, videos) {
  activeVideoIndex = ++activeVideoIndex % videos.length;
  if (el.dataset.currentVideoPhxEvent) {
    _this.pushEvent(el.dataset.currentVideoPhxEvent, activeVideoIndex + 1);
  }
}

function clearTimeouts() {
  while (timeouts.length) {
    clearTimeout(timeouts.pop());
  }
}
